function $eab59e10d424e744$export$2e2bcd8739ae039() {
    const itemsRef = document.querySelectorAll('.tasks__item');
    const namberRef = document.querySelector('.tasks__count');
    namberRef.textContent = itemsRef.length;
}


function $e2faaa1621bf62b6$export$2e2bcd8739ae039() {
    const listRef = document.querySelector('.tasks__list');
    listRef.addEventListener('click', (e)=>{
        const itemRef = e.target.closest('.tasks__item');
        if (e.target.classList.contains('tasks__delete-btn')) {
            itemRef.remove();
            (0, $eab59e10d424e744$export$2e2bcd8739ae039)();
        }
    });
}


/* @ts-self-types="./index.d.ts" */ let $e7016a9af9b25e86$export$2b646eea95309f00 = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';


let $cf399e049a9c4d34$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $cf399e049a9c4d34$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
    let mask = (2 << Math.log2(alphabet.length - 1)) - 1;
    let step = -~(1.6 * mask * defaultSize / alphabet.length);
    return (size = defaultSize)=>{
        let id = '';
        while(true){
            let bytes = getRandom(step);
            let j = step | 0;
            while(j--){
                id += alphabet[bytes[j] & mask] || '';
                if (id.length >= size) return id;
            }
        }
    };
};
let $cf399e049a9c4d34$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$cf399e049a9c4d34$export$a5cee9e955a615e5(alphabet, size | 0, $cf399e049a9c4d34$export$4385e60b38654f68);
let $cf399e049a9c4d34$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = '';
    let bytes = crypto.getRandomValues(new Uint8Array(size |= 0));
    while(size--)id += (0, $e7016a9af9b25e86$export$2b646eea95309f00)[bytes[size] & 63];
    return id;
};



function $f075a2a7e828e7d9$var$createTaskHTML(text) {
    return `
    <div class="tasks__item" data-id="${(0, $cf399e049a9c4d34$export$ac4959f4f1338dfc)(5)}">
      <div>
        <input type="checkbox" class="tasks__checkbox">
        <span class="tasks__text">${text}</span>
      </div>
      <div class="tasks__width">
        <button class="tasks__edit-btn">rename</button>
        <button class="tasks__delete-btn">delete</button>
      </div>
    </div>
  `;
}
function $f075a2a7e828e7d9$export$2e2bcd8739ae039(text) {
    const listRef = document.querySelector('.tasks__list');
    listRef.insertAdjacentHTML('beforeend', $f075a2a7e828e7d9$var$createTaskHTML(text));
    (0, $eab59e10d424e744$export$2e2bcd8739ae039)();
}


function $cbf510e049c0cba6$export$2e2bcd8739ae039(creatElem) {
    const btnRef = document.querySelector('.tasks__add-btn');
    btnRef.addEventListener('click', ()=>{
        const text = document.querySelector('.tasks__input').value;
        if (text.trim() === '') alert('Name text');
        else creatElem(text);
    });
}


function $d8cf4a4827caef0c$export$2e2bcd8739ae039() {
    const listRef = document.querySelector('.tasks__list');
    listRef.addEventListener('click', (e)=>{
        const taskItem = e.target.closest('.tasks__item');
        if (e.target.classList.contains('tasks__checkbox') & e.target.checked === true) taskItem.classList.add('tasks__item-true');
        if (e.target.classList.contains('tasks__checkbox') & e.target.checked === false) taskItem.classList.remove('tasks__item-true');
    });
}



(0, $cbf510e049c0cba6$export$2e2bcd8739ae039)((0, $f075a2a7e828e7d9$export$2e2bcd8739ae039));
(0, $e2faaa1621bf62b6$export$2e2bcd8739ae039)();
(0, $d8cf4a4827caef0c$export$2e2bcd8739ae039)();
(0, $eab59e10d424e744$export$2e2bcd8739ae039)();
const $6f40c3a58f594b58$var$listRef = document.querySelector('.tasks__list');
$6f40c3a58f594b58$var$listRef.addEventListener('click', (e)=>{
    if (e.target.closest('.tasks__edit-btn')) alert("\u0444\u0443\u043D\u043A\u0446\u0456\u044F \u0432 \u0440\u043E\u0437\u0440\u043E\u0431\u0446\u0456");
});


//# sourceMappingURL=Todolist-parsel.a4dfbbff.js.map
